// v2 is mounted behind a flag so it can be built and verified beside the live v1
// UI (docs/frontend-v2/). Enabled by a build-time env (VITE_FE_V2) OR a `?v2=1`
// URL param (sticky via localStorage), so we can flip a deployed build without a
// rebuild. `?v2=0` turns it back off. Every access is wrapped — a private window
// or blocked storage must not crash the app.
export function isV2Enabled(): boolean {
  try {
    const params = new URLSearchParams(window.location.search);
    const q = params.get("v2");
    if (q === "1") {
      localStorage.setItem("fe_v2", "1");
      return true;
    }
    if (q === "0") {
      localStorage.removeItem("fe_v2");
      return false;
    }
    if (localStorage.getItem("fe_v2") === "1") return true;
  } catch {
    // ignore — fall back to the build-time flag below
  }
  const env = import.meta.env.VITE_FE_V2;
  return env === "1" || env === "true";
}
